import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from 'react';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { Container, Embed, EmbedIcon, EmbedTitle, Header } from './EmbedBlock.style';

var EmbedBlock = function EmbedBlock(_ref) {
  var block = _ref.block,
      editorState = _ref.blockProps.editorState;

  var _useState = useState(''),
      embedData = _useState[0],
      setEmbedData = _useState[1];

  var _useState2 = useState(true),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useGetBlockData = useGetBlockData(editorState, block.getKey(), block.getEntityAt(0)),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setOpenModal(blockData.openModal);
    setEmbedData(entityData.embedData);
  }, [blockData, entityData]);
  return __jsx(Container, null, __jsx(Header, {
    contentEditable: false
  }, __jsx(EmbedIcon, null), __jsx(EmbedTitle, null, "Embed content")), (embedData || !openModal) && __jsx(Embed, null, embedData));
};

export default EmbedBlock;